<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="8">
            <el-form-item :label="$t('매장')">
              <!-- 조건이 바뀐 조회는 **1페이지부터**다 — 3페이지에서 매장을 바꾸면 그 3페이지는
                   다른 결과 집합의 3페이지라 흔히 빈 표가 온다([pagedListMixin.searchFirstPage]) -->
              <StorePicker v-model="searchForm.storeCd" :options="store" @change="searchFirstPage" />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item :label="$t('옵션명')">
              <el-input v-model="searchForm.smenuOptNm" @keyup.enter.native="searchFirstPage" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('SmenuOptSearch')"
        :size="size"
        @click="searchFirstPage"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuOptAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuOptUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuOptDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked"
      @sort-change="handleSortChange">
      <el-table-column
        :label="totalElements.toString()"
        type="index"
        width="55"
        align="center"
        label-class-name="data_cnt"
        :index="indexMethod"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>
      <!-- 정렬은 **서버**가 한다(`sortable="custom"`) — 페이징된 목록에서 `sortable` 은 「이 페이지 안에서만」이라
           사람이 본 순서와 서버가 고른 한 장이 서로 다른 말을 한다 -->
      <el-table-column :label="$t('옵션명')" prop="smenuOptNmLan" min-width="200" sortable="custom"></el-table-column>
      <!-- 옵션 구분은 **평면 필드**다 — 목록 행은 표시용 프로젝션이라 중첩 `smenuOptTp` 객체를 싣지 않는다.
           점 표기(`smenuOptTp.smenuOptTpNm`)는 화면의 어휘일 뿐 서버가 아는 컬럼 이름이 아니다 -->
      <el-table-column
        :label="$t('옵션 구분')"
        prop="smenuOptTpNm"
        min-width="100"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column
        :label="$t('표시 순서')"
        prop="ord"
        min-width="100"
        align="center"
        sortable="custom"></el-table-column>
      <el-table-column
        :label="$t('원가')"
        prop="cost"
        min-width="100"
        align="right"
        sortable="custom"
        :formatter="mainVue.formatterPrice"></el-table-column>
      <el-table-column
        :label="$t('단가')"
        prop="priceLan"
        min-width="100"
        align="right"
        sortable="custom"
        :formatter="mainVue.formatterPrice"></el-table-column>
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="110"
        align="center"
        sortable="custom"
        :formatter="mainVue.formatterCode"></el-table-column>
      <!--
        옵션 품절 — 점주 「옵션 관리」와 같은 토글·같은 API(그룹 브로드캐스트, R-S). 그 쓰기의 세션 액션이 없는 세션에는
        열째 없다(보안 계층 403 은 이 앱에서 로그아웃이다)
      -->
      <el-table-column
        v-if="checkAuthActionAccess(stopSellingAction)"
        :label="$t('품절')"
        min-width="80"
        align="center">
        <template slot-scope="scope">
          <OptStopSellingSwitch :smenu-opt-cd="scope.row.smenuOptCd" v-model="scope.row.stopSelling" />
        </template>
      </el-table-column>
      <!--			<el-table-column :label="$t('설명')" 			prop="smenuOptDesc" min-width="300" show-overflow-tooltip></el-table-column>-->
    </el-table>
    <list-pagination
      :search-form="searchForm"
      :total="totalElements"
      @page-change="handlePageChange"
      @size-change="handleSizeChange"></list-pagination>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        label-width="140px"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row :gutter="20">
          <el-col :md="inputForm.smenuOptInfos.length > 0 ? 12 : 24">
            <el-tabs value="info">
              <el-tab-pane :label="$t('기본 정보')" name="info">
                <el-row :gutter="20">
                  <el-col :span="inputForm.smenuOptInfos.length > 0 ? 24 : 12">
                    <el-form-item :label="$t('매장')" required>
                      <StorePicker
                        v-if="'I' === inputForm.statu"
                        v-model="inputForm.store.storeCd"
                        :options="store"
                        @change="storeInputSelect" />
                      <span v-else class="show_cd">{{ inputForm.store.storeNmLan }}</span>
                    </el-form-item>
                    <el-form-item :label="$t('옵션명')" :error="formError.smenuOptNm" required>
                      <el-input v-model="inputForm.smenuOptNm" maxlength="50" clearable show-word-limit>
                        <el-button
                          v-if="lans.length > 1"
                          slot="append"
                          :size="size"
                          @click="dictionaryDialogFormVisible = true"
                          icon="el-icon-search"
                          >{{ $t('다국어 조회') }}</el-button
                        >
                      </el-input>

                      <!-- 사전 선택 -->
                      <DictionaryDialog
                        :visible="dictionaryDialogFormVisible"
                        @close="dictionaryDialogFormVisible = false"
                        @selectDictionary="selectDictionary" />
                    </el-form-item>

                    <el-form-item :label="$t('원가')" :error="formError.cost" required>
                      <el-input-number
                        v-model="inputForm.cost"
                        :step="100"
                        :min="0"
                        :max="90000000"
                        style="width: 200px"></el-input-number>
                    </el-form-item>

                    <el-form-item :label="$t('단가')" :error="formError.price" required>
                      <el-input-number
                        v-model="inputForm.price"
                        :step="100"
                        :min="0"
                        :max="90000000"
                        style="width: 200px"></el-input-number>
                    </el-form-item>

                    <el-form-item :label="$t('옵션 구분')" :error="formError['smenuOptTp.smenuOptTpCd']" required>
                      <opt-tp-combo
                        :data="smenuOptTp"
                        :model="inputForm.smenuOptTp.smenuOptTpCd"
                        @change="inputForm.smenuOptTp.smenuOptTpCd = $event"></opt-tp-combo>
                    </el-form-item>

                    <el-form-item :label="$t('표시 순서')" :error="formError.ord" required>
                      <el-input-number v-model="inputForm.ord" :min="1" :max="99"></el-input-number>
                    </el-form-item>
                    <el-form-item :label="$t('사용 가능 여부')" required>
                      <combo
                        :data="mainVue.code.useYn"
                        :model="inputForm.useYn"
                        @change="inputForm.useYn = $event"></combo>
                    </el-form-item>
                    <!--										<el-form-item :label="$t('설명')" :error="formError.smenuOptDesc">-->
                    <!--											<el-input v-model="inputForm.smenuOptDesc" type="textarea" maxlength="250" show-word-limit></el-input>-->
                    <!--										</el-form-item>-->
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <el-col :md="12" v-if="inputForm.smenuOptInfos.length > 0">
            <el-tabs v-model="activiTab">
              <el-tab-pane
                v-for="(item, index) in inputForm.smenuOptInfos"
                :key="item.lanTp.id"
                :label="item.lanTp.nm"
                :name="item.lanTp.id">
                <el-form-item
                  :label="$t('옵션명')"
                  :error="formError['smenuOptInfos[' + index + '].smenuOptInfoNm']"
                  required>
                  <el-input
                    v-model="inputForm.smenuOptInfos[index].smenuOptInfoNm"
                    maxlength="50"
                    clearable
                    show-word-limit></el-input>
                </el-form-item>

                <el-form-item
                  :label="$t('단가')"
                  :error="formError['smenuOptInfos[' + index + '].price']"
                  required
                  v-if="inputForm.store.internationalPayYn">
                  <el-input-number
                    v-model="inputForm.smenuOptInfos[index].price"
                    :min="0"
                    :max="90000000"
                    style="width: 200px"></el-input-number>
                </el-form-item>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
        <el-dialog
          title="Warning"
          :visible.sync="closeDialogVisible"
          width="300px"
          :modal="false"
          :modal-append-to-body="false"
          :append-to-body="true"
          center>
          <span>정말로 페이지를 닫으시겠습니까?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialogVisible = false">아니요</el-button>
            <el-button
              type="primary"
              @click="
                closeDialogVisible = false
                dialogFormVisible = false
              "
              >예</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 대리점
import StorePicker from '@/components/store/StorePicker.vue'
import DictionaryDialog from '@/components/dictionary/DictionaryDialog.vue'
import OptStopSellingSwitch from '@/components/store/OptStopSellingSwitch.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import pagedListMixin from '@/mixins/pagedListMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { withPaging } from '@/utils/pagedList'
import { STORE_OPTIONS_API, firstStoreOf, storeLansOf, storeOptionsOf, storeOptionsQuery } from '@/utils/storeOptions'
import storeOptionResolver from '@/mixins/storeOptionResolver'
import { deliveryOptionDeleteHidesNote } from '@/utils/deliveryMenuNotes'
import { MENU_BOARD_WRITE_ACTION } from '@/utils/deliveryMenuSync'
import { syncLangValue } from '@/utils/syncLangValue'

export default {
  mixins: [mainVueMixin, pagedListMixin, storeOptionResolver],

  components: {
    StorePicker,
    DictionaryDialog,
    OptStopSellingSwitch,
  },

  data: function () {
    var data = initData()
    data.url = '/smenuOpt'
    data.store = []
    data.smenuOptTp = []
    data.activiTab = ''
    /** 옵션 품절 토글의 세션 액션(메뉴판 쓰기) — 없으면 품절 열을 그리지 않는다 */
    data.stopSellingAction = MENU_BOARD_WRITE_ACTION

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.lans = []
    data.popTableData = []

    data.dictionaryDialogFormVisible = false
    data.searchText = ''

    data.closeDialogVisible = false
    return data
  },
  created: function () {
    this.initStore()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    // ★ **단가 수정 이벤트 감지** — 매장 화면(`*ForStoreView`)과 **같은 규칙**이다 (§16.219⑤).
    //
    // 이 관리자 화면들에는 이 감지가 아예 없어서, 타국화폐 결제를 안 쓰는 매장에서 본 단가를
    // 고쳐도 **언어 탭 값이 옛 가격으로 남았다.** 매장 화면 세 곳만 고치고 여기를 빠뜨리면
    // 「어느 저장 경로로도」가 참이 되지 않는다 — 같은 메뉴를 두 화면에서 고칠 수 있다.
    //
    // 동기화 로직 자체는 `utils/syncLangValue` 한 곳이 소유한다(인덱스 루프를 다시 적지 않는다).
    'inputForm.price': function () {
      if (!this.inputForm.store.internationalPayYn) {
        syncLangValue(this.inputForm.smenuOptInfos, 'price', this.inputForm.price)
      }
    },
    formError: {
      deep: true,
      handler: function (newVal, oldVal) {
        // 벨리데이션 메세지가 값은 있는데 Vue에서 표시 안해주는 현상 처리 하기 위함
        setTimeout(
          function () {
            var tmp = this.inputForm.smenuOptNm
            this.inputForm.smenuOptNm = this.inputForm.smenuOptNm + ' '
            this.inputForm.smenuOptNm = tmp

            var i = 100
            for (let val in newVal) {
              if (val.indexOf('smenuOptInfos') > -1) {
                if ('' != newVal[val]) {
                  if (i > val.replace(/[^0-9]*/g, '')) {
                    i = parseInt(val.replace(/[^0-9]*/g, ''))
                  }
                }
              }
            }

            if (100 != i) {
              this.activiTab = this.inputForm.smenuOptInfos[i].lanTp.id
            }
          }.bind(this),
          500
        )
      },
    },
  },
  methods: {
    // 검색 조건 초기화 — 페이징·정렬 축은 [withPaging] 이 붙인다
    // (기본 50건·첫 페이지·서버 기본 정렬 `ord ASC, smenuOptCd ASC`)
    initSearchForm: function () {
      return withPaging({
        storeCd: null,
        smenuOptNm: '',
        useYn: 'Y',
      })
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        smenuOptCd: 0,
        defaultLan: { id: '' },
        smenuOptNm: '',
        cost: 0,
        price: 0,
        smenuOptInfos: [],
        store: { storeCd: null, internationalPayYn: false },
        smenuOptTp: { smenuOptTpCd: null, smenuOptTpNm: '' },
        ord: 0,
        useYn: 'Y',
        smenuOptDesc: '',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        smenuOptNm: '',
        cost: '',
        price: '',
        'smenuOptTp.smenuOptTpCd': '',
        ord: '',
        useYn: '',
        smenuOptDesc: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].smenuOptCd
      }
    },
    // 매장 자동 검색 — 셀렉트 전용 경량 조회다. URL·조건은 [storeOptionsQuery] 한 곳이 소유한다
    initStore: function () {
      this.mainVue.$axios.search(
        STORE_OPTIONS_API,
        storeOptionsQuery(),
        function (result) {
          this.store = storeOptionsOf(result)

          // 매장이 하나도 없는 계정은 빈 셀렉트·빈 표가 옳다 — 매장 축 없는 조회는 건너뛴다
          const first = firstStoreOf(this.store)
          if (first == null) return

          // 검색 칸의 기본 매장과 첫 조회는 [StorePicker] 가 소유한다 — 화면마다 복제하지 않는다
          this.inputForm.store.storeCd = first.storeCd
          this.inputForm.store.internationalPayYn = first.internationalPayYn
          this.inputForm.defaultLan = first.defaultLan

          this.initStoreLans(first)

          this.initSmenuOptTp(first.storeCd)
        }.bind(this)
      )
    },
    // 사전 조회를 위한 언어 정보 설정
    // 순서(기본 언어가 맨 앞)는 [storeLansOf] 한 곳이 소유한다
    initStoreLans: function (store) {
      this.lans = storeLansOf(store)
    },
    // 고른 매장의 메타데이터를 폼에 적는다 — 진입점 둘(사람·씨앗)은 [storeOptionResolver] 가 갖고
    // 화면은 이 본문만 구현한다. 못 얻으면 아무것도 바꾸지 않는다
    applyStoreOption: async function (storeCd, pending) {
      this.initSmenuOptTp(storeCd)

      const option = await pending
      if (!option) return

      // 국제 화페 단위 결제 여부
      this.inputForm.store.internationalPayYn = option.internationalPayYn

      // 디폴트 언어 설정
      this.inputForm.defaultLan = option.defaultLan
      this.initStoreLans(option)

      // 수정 시 매장 다국어 삭제 시 카테고리도 다국어 지워줌
      var smenuOptInfosTmp = []

      if (this.inputForm.statu == 'U') {
        smenuOptInfosTmp = util.copyObj(this.inputForm.smenuOptInfos)
      }

      this.inputForm.smenuOptInfos = []

      for (var j = 0, jlen = option.lans.length; j < jlen; j++) {
        this.formError['smenuOptInfos[' + j + '].smenuOptInfoNm'] = ''
        this.formError['smenuOptInfos[' + j + '].price'] = ''

        var smenuOptInfoNm = ''
        var price = 0

        if (this.inputForm.statu == 'U') {
          for (var k = 0, klen = smenuOptInfosTmp.length; k < klen; k++) {
            if (smenuOptInfosTmp[k].lanTp.id == option.lans[j].id) {
              smenuOptInfoNm = smenuOptInfosTmp[k].smenuOptInfoNm
              price = smenuOptInfosTmp[k].price
            }
          }
        }

        this.inputForm.smenuOptInfos.push({
          lanTp: option.lans[j],
          smenuOptInfoNm: smenuOptInfoNm,
          price: price,
        })

        if (j === 0) {
          this.activiTab = option.lans[j].id
        }
      }

      // ★★ **새 언어 행은 0 으로 태어난다** (`I18N-ROW-SEED`) — 위 복사는 이전 행이 있을
      // 때만 값을 옮긴다. 기본값을 여기서 계산하지 않고 **동기화의 소유자**를 한 번 부른다
      // (`I18N-PRICE-LOOP` 가 없앤 「여섯 벌의 같은 계산」을 다시 만들지 않는다).
      // 타국화폐 결제 매장은 일부러 언어별 값을 따로 정하므로 건드리지 않는다.
      if (!this.internationalPayYn) {
        syncLangValue(this.inputForm.smenuOptInfos, 'price', this.inputForm.price)
      }
    },
    // 옵션 구분 조회
    initSmenuOptTp: function (storeCd) {
      this.mainVue.$axios.search(
        '/smenuOptTp',
        { storeCd: storeCd, smenuOptTpNm: '', useYn: 'Y' },
        function (result) {
          this.smenuOptTp = result

          this.inputForm.smenuOptTp =
            this.smenuOptTp.length > 0 ? util.copyObj(this.smenuOptTp[0]) : { smenuOptTpCd: null, smenuOptTpNm: '' }
        }.bind(this)
      )
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('옵션 추가')
      this.formError = this.initFormError()

      if (this.store.length > 0) {
        this.inputForm.store = { storeCd: util.copyObj(this.searchForm.storeCd) }
        this.storeSeedSelect(this.inputForm.store.storeCd)
      }

      // 순번 자동 — 서버에 「이 조건에서 가장 큰 `ord`」 한 행만 묻고 그 다음 수를 쓴다.
      // 화면이 가진 목록으로 세면 **지금 보고 있는 한 장**의 최댓값이라, 2페이지에 더 큰 값이
      // 있어도 모른 채 이미 쓰는 순번을 다시 내준다. 창은 답이 온 뒤에 연다(실패해도 열린다).
      this.fetchNextSequence(
        'ord',
        function (ord) {
          this.inputForm.ord = ord

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this)
      )
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.smenuOptCd,
        function (result) {
          result.statu = 'U'
          result.title = this.$t('옵션 수정')

          this.inputForm = result

          this.formError = this.initFormError()

          this.storeSeedSelect(this.inputForm.store.storeCd)

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchQuery(),
        function (result) {
          this.applyPage(result)

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제 — 이 화면은 배달 링크를 읽지 않으므로 조건문으로 말한다(§16.302 · 문구는 utils/deliveryMenuNotes)
    del: function () {
      this.mainVue
        .$confirm(
          this.$t('옵션 정보를 삭제 하시겠습니까?') + ' ' + this.$t(deliveryOptionDeleteHidesNote(null)),
          this.mainVue.appMsg.systemAlterTitle,
          {
            confirmButtonText: this.$t('삭제'),
            cancelButtonText: this.$t('취소'),
            type: 'info',
          }
        )
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      for (var i = 0, len = this.inputForm.smenuOptInfos.length; i < len; i++) {
        this.formError['smenuOptInfos[' + i + '].smenuOptInfoNm'] = ''
        this.formError['smenuOptInfos[' + i + '].price'] = ''
      }

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.smenuOptCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      }
    },
    searchDictionary: function (searchText) {
      this.mainVue.$axios.search(
        '/dictionary/search',
        { nm: this.searchText, dictionaryTpVal: 'opt' },
        function (result) {
          this.popTableData = []

          for (var i = 0, len = result.length; i < len; i++) {
            var tmp = result[i]

            tmp[result[i].lan.id] = result[i].nm

            for (var j = 0, jlen = result[i].dictionarys.length; j < jlen; j++) {
              tmp[result[i].dictionarys[j].lan.id] = result[i].dictionarys[j].nm
            }

            this.popTableData.push(tmp)
          }
        }.bind(this),
        true
      )
    },
    // 키워드 데이타 선택
    selectDictionary: function (row) {
      for (var i = 0, len = this.lans.length; i < len; i++) {
        // 기본 언어 새팅
        if (0 == i) {
          this.inputForm.smenuOptNm = row[this.lans[i].id]
        } else {
          // 타언어 순서대로 등록
          this.inputForm.smenuOptInfos[i - 1].smenuOptInfoNm = row[this.lans[i].id]
        }
      }

      this.dictionaryDialogFormVisible = false
    },
  },
}
</script>
